import constants from '@next-app/constants/constants';

export const isPagePDP = (page: any) => page === constants.PDP;
